import { memo, useEffect } from "react";
import { connect } from "react-redux";
import { MedicoViewProps, mapDispatchToMedicoProps, mapStateToMedicoProps, medicoController } from "../medico.controller";
import { Autocomplete, Box, IconButton, Stack, TextField, Typography } from "@mui/material";
import { Medico } from "../medico.model";
import { ArrowDropDown, Search } from "@mui/icons-material";
import { ClearIcon } from "@mui/x-date-pickers";
import Modal from "../../../components/modal";
import { columnsMedico } from "./medico.list";
import { Select as ViewList } from "../../../components/select";
import { MedicoCadastro } from "./medico.cad";
import store from "../../../store";


interface MedicoAutoCompletProps extends MedicoViewProps {
    handleSelectMedico: (row: Medico) => any
}


function MedicoAutoComplete(props: MedicoAutoCompletProps) {
    const { medicoActions,medicoState, handleSelectMedico } = props
    const { rows } = medicoState
    useEffect(() => {
        console.log("chamou ")
        medicoActions.read();
    }, [])

    const handleSelect = (row: Medico) => {
        console.log("selecionou Medico " + row)
        handleSelectMedico(row)
    }

    return (
        <Autocomplete
            fullWidth
            options={rows}
            autoHighlight
            getOptionLabel={(row) => row.nome}
            getOptionKey={(row) => row._id}
            title="Selecionar profissional"
            selectOnFocus
            clearOnBlur
            handleHomeEndKeys
            disableClearable
            //popupIcon={<Search fontSize="small"  titleAccess="Selecionar Medico"/>}
            clearIcon={<ClearIcon fontSize="small" titleAccess="Remover" />}
            renderOption={((props, medico) => {
                const { key, ...optionProps } = props
                return (
                    <Box
                        key={key}
                        component={"li"}
                        {...optionProps}
                    >
                        <Stack flexDirection={"column"}>
                            <Typography variant="body1">{medico.nome}</Typography>
                        </Stack>
                    </Box>
                )
            })}
            renderInput={(params) =>
                <TextField
                    {...params}
                    label="Selecionar profissional"
                    slotProps={{
                        htmlInput: {
                            ...params.inputProps,
                            autoComplete: 'new-password', // disable autocomplete and autofill
                        },
                    }}
                />
            }
            onChange={(ev, medico) => {
                ev.preventDefault();
                if (medico)
                    handleSelect(medico);
            }}
        />
    )
}
interface SelecionarMedicoProps extends MedicoViewProps {
    handleConfirmar: (medico: Medico) => any;
}

const SelecionarMedico = memo((props: SelecionarMedicoProps) => {
    const { medicoActions,medicoState, handleConfirmar } = props
    const { error, loadingRows, msg, row, rows, showAlert, status, showCadModal, changeList, showSelectModal } = medicoState
    const { read, setShowAlert, setClearValue, setShowCadModal, setShowSelectModal } = medicoActions

    console.log("carregou Selecionar Medico",props.medicoState)
    const handleNovo = () => {
        setClearValue();
        setShowCadModal(true)
    }

    function Cadastro() {
        return MedicoCadastro({
            ...props,
            handleCloseView: () => setShowCadModal(false)
        }).renderModal({
            handleClose: () => setShowCadModal(false),
            show: showCadModal,
            heigth: "auto",
            width:"sm"
        })
    }

    const handleSelecionar = (medico:Medico) => {
        handleConfirmar(medico);
        setShowSelectModal(false);
    }

    const List = () => {
        return (
            <>
                <ViewList
                    displayWidth={window.innerWidth}
                    title={"Selecionar Profissional"}
                    row={row}
                    showAlert={showAlert}
                    closeAlert={() => setShowAlert(false)}
                    msg={msg}
                    status={status}
                    elevation={1}
                    getRowId={(row: Medico) => row._id}
                    handleOnChange={handleSelecionar}
                    actionsOnkeyEnter={handleSelecionar}
                    showSearchContainer={true}
                    fontSize={20}
                    setTextSearch={() => { }}
                    textSearch={""}
                    fieldSearch={"nome"}
                    placeholderTextSearch="Buscar profissional"
                    variantToobar="dense" 
                    columns={columnsMedico}
                    rows={rows}
                    loading={loadingRows}
                    setRow={handleSelecionar}
                    changeList={changeList}
                    buttonNew={{
                        show: false,
                        onClick: handleNovo
                    }}
                    buttonRefresh={{
                        show: true,
                        onClick: () => read()
                    }}
                    ListItemTextPrimary={(row: Medico) => <Typography component={"span"}>{row.nome}</Typography>}
                />
                <Cadastro />
            </>
        )
    }

    return (
        <Modal
            component={<List />}
            handleClose={() => setShowSelectModal(false)}
            open={showSelectModal}
            heigth="auto"
            width="sm"
            handleOnKeyDown={() => { }}
        />
    )
},(prev,next)=>{
    return prev.medicoState.showSelectModal === next.medicoState.showSelectModal&&
    prev.medicoState.changeList === next.medicoState.changeList
})

export default connect(mapStateToMedicoProps, mapDispatchToMedicoProps)(MedicoAutoComplete)
export const ViewSelecionarMedico = connect(mapStateToMedicoProps, mapDispatchToMedicoProps)(SelecionarMedico)

export const handleShowSelecionarMedico = (set:boolean) => {
    if(medicoController.state.rows.length === 0)
        store.dispatch(medicoController.reducer.actions.read());
    store.dispatch(medicoController.reducer.actions.setShowSelectModal(set))
}